import { render } from "./ShoppingListContentScreen.vue?vue&type=template&id=2b6a517a&scoped=true"
import script from "./ShoppingListContentScreen.vue?vue&type=script&lang=js"
export * from "./ShoppingListContentScreen.vue?vue&type=script&lang=js"

import "./ShoppingListContentScreen.vue?vue&type=style&index=0&id=2b6a517a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b6a517a"]])

export default __exports__